<template>
  <div class="signup app-content bg-gray">
    <div class="bg-gray pb-5">
      <div class="container bg-gray">
        <div class="row mx-0 pb-2">
          <div class="col-12 p-0">
            <router-link :to="'./mypage'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
            </router-link>
            <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
            <router-link :to="'./news'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.of_news_list")}}</p>
            </router-link>
          </div>
        </div>
        <div class="row pt-4 mb-2">
          <div class="col-12 py-2">
            <p class="article_title mb-12"><b>{{$t("message.news_tpic")}}</b></p>
            <b-card >
              <ul class="px-0">
                <li class="pb-2 news-li shortcut mb-2" v-for="news in getItems" :key="news" >
                  <router-link :to="'./news/' + news.id">
                    <span class="mgr-10" style="display: inline">{{format_day_news(news)}}</span><h5 v-html="format_news(news)" style="display: inline"></h5><br>
                  </router-link>
                </li>
              </ul>
              <div class="col-6 col-md-2 mx-auto">
               <paginate
                :page-count="getPageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'＜'"
                :next-text="'＞'"
                :container-class="'pagination'"
                :page-class="'page-item' "
                :page-link-class="'page-link'"
                :prev-class="'page-item'"
                :prev-link-class="'page-link'"
                :next-class="'page-item'"
                :next-link-class="'page-link'"
                >
              </paginate>
              </div>
            </b-card>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import Paginate from 'vuejs-paginate'

export default {
  components: {
    Paginate,
  },
  data () {
    return {
      occupation: undefined,
      news_list: [],
      idToken: localStorage.idToken,
      parPage: 10,
      currentPage: 1,
      meta: {}
    }
  },
  methods: {
    format_news(news){
      const format = news['title']
      return format
    },
    clickCallback: function (pageNum) {
      this.currentPage = Number(pageNum);
    },
    fetch_news: function() {
      var lang = ''
      if(this.language == 'kh'){
        lang = 'km'
      }else if(this.language == 'lk'){
        lang = 'si'
      }else{
        lang = this.language
      }
      axios
      .get(process.env.VUE_APP_API + "/news?lang=" + lang ,{headers: {'Authorization': 'Bearer ' + this.idToken},params: {
          industry_id: this.memberInfo.current_industry
        }})
      .then(response => {
        this.news_list = response.data.news
        this.meta = response.data.meta

      }).catch(error => {
        console.log('this is error', error)
      })
    },
  },
  async mounted() {
    if( this.memberInfo.status == 'associate_member'){
      this.$router.push('./createUser')
    }else{
      if (this.memberInfo.status == "no_deposite_member") {
        //this.$router.push('./payment')
      }
    }
    this.occupation = this.memberInfo.current_industry
    this.fetch_news()
    this.$store.commit('setLoading', false)
  },

  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        language: state => state.language
    }),
    getItems: function() {
      let current = this.currentPage * this.parPage;
      let start = current - this.parPage;
      console.log(this.news_list)
      return this.news_list.slice(start, current);
    },
    getPageCount: function() {
      return Math.ceil(this.meta.total / this.parPage);
    }
  },
  watch:{
    memberInfo(val){
      this.occupation = val.current_industry
    },
    language(){
      this.fetch_news()
    }
  },
}
</script>

<style scoped lang="scss">
.article_title{
  font-weight: bold;
  font-size: 16px;
}

.news-li{
  list-style: none;
  a {
    color: #495057;
    text-decoration: underline;
  }
}

</style>
